import { PropsWithChildren } from 'react';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

type MedicalDataAccessConsentWithdrawEventInterceptorProps = PropsWithChildren<unknown>;

const MedicalTreatmentConsentWithdrawEventInterceptor = (
   props: MedicalDataAccessConsentWithdrawEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'medicalTreatmentConsentWithdraw'}
         shouldShowModal
         title={patientConsentsAndAuthorizationsTranslationKeys.consent.withdrawConsent}
         confirmationButtonLabel={patientConsentsAndAuthorizationsTranslationKeys.consent.withdrawButtonLabel}
         content={patientConsentsAndAuthorizationsTranslationKeys.consent.withdrawQuestion}
         modalWidth={ModalWidth.NORMAL}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};

export { MedicalTreatmentConsentWithdrawEventInterceptor };
